import { module } from 'constant'
import { defaultTrans } from 'crosstab/dist-lib/crosstab.es'
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
// @ts-ignore

import crossTable from './crossTable.vue'

const { crossTableVue } = module.crossTable

const defaultLocale = 'en'
export const i18n = createI18n({
	locale: defaultLocale,
	fallbackLocale: defaultLocale,
	missingWarn: false,
	legacy: false,
	globalInjection: true,
	messages: {
		en: defaultTrans,
	},
})

export const CrossTableVue = () => {
	const init = () => {
		const app = createApp(crossTable)
		app.use(i18n)
		app.config.performance = true
		app.mount(crossTableVue.instance)
	}

	return {
		init,
		i18n,
	}
}
